export const useForms = () => {
  const redirectToPreviousPage = () => {
    navigateToInternal("/infos-et-services/aide/contactez-nous")
  }

  return {
    redirectToPreviousPage
  }
}